<template>
  <div class="online-content">
    <div class="review-home">
      <div class="review-title">
        <template v-if="from == 'list' && navList.length > 1 && navList[1]['mapsList'].length > 0">
          <div class="item-list">
            <router-link
              :to="{path: '/Review/ReviewList'}"
              tag="p"
              class="item"
            >{{ navList['0']['classcode_name'] }}</router-link>
            <router-link
              :to="{path: '/Review/PrevList'}"
              tag="p"
              class="item"
            >{{ navList['1']['classcode_name'] }}</router-link>
          </div>
        </template>
        <template v-else>
          <p>{{ title }}</p>
        </template>
        <em @click="bakToPrev" class="back_arrow"></em>
      </div>
      <div class="review-content">
        <slot></slot>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "review-home",
  props: ["title", "from", "navList"],
  methods: {
    bakToPrev() {
      this.$emit("bakToPrev");
    }
  }
};
</script>
<style lang="less">
.review-home {
  height: 100%;
  border-radius: 20px;
  .review-title {
    height: 65px;
    display: flex;
    padding: 0 20px;
    align-items: center;
    justify-content: space-between;
    font-size: 16px;
    color: #181818;
    border-radius: 10px 10px 0 0;
    background-color: #fff;
    box-shadow: 0px 2px 5px 0px rgba(0, 0, 0, 0.05);
    .item-list {
      display: flex;
      align-items: center;
      .item {
        margin-right: 20px;
        font-size: 16px;
        color: #444;
        line-height: 22px;
        cursor: pointer;
      }
    }
    .back_arrow {
      width: 24px;
      height: 24px;
      background: url("../../assets/images/studyCenter/back-icon.png") center
        center no-repeat;
      background-size: 100% 100%;
      cursor: pointer;
    }
  }
  .review-content {
    height: calc(100% - 65px);
    margin-top: 1px;
    background-color: #fff5ef;
    border-radius: 0 0 10px 10px;
    box-shadow: 0px 2px 5px 0px rgba(0, 0, 0, 0.05);
  }
}
</style>